export default __webpack_public_path__ + "static/media/stabs-hits-144.cebd5247.mp3";